export default __webpack_public_path__ + "static/media/i233hk.7c6f84c8.webp";